import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Copyright © 2025-2026 Cognizant Digital Business, Evolutionary AI.
 * All Rights Reserved.
 * Issued under the Academic Public License.
 */
// END COPYRIGHT
// Adapted from neuro-san-ui packages/ui-common/components/Settings/ApiKeyErrorBanner.tsx
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import httpStatus from "http-status";
// http-status v2 types its map with literal keys and no numeric index, so widen it to index by code
const STATUS_PHRASE = httpStatus;
const errorTitle = ({ vendor, result: { status: statusCode } }) => statusCode !== undefined
    ? `${vendor} — ${STATUS_PHRASE[statusCode] ?? "Unknown status"} (${statusCode})`
    : `${vendor} — Request failed`;
const ApiKeyErrorBanner = ({ failures }) => {
    if (failures.length === 0) {
        return null;
    }
    return (_jsx(Alert, { severity: "error", sx: { width: "100%" }, children: _jsx(Box, { sx: { display: "flex", flexDirection: "column", gap: 1.5, minWidth: 0 }, children: failures.map((failure) => (_jsxs(Box, { children: [_jsx(Typography, { sx: { fontWeight: 700 }, variant: "body2", children: errorTitle(failure) }), failure.result.message ? (_jsx(Typography, { sx: { mt: 0.25, overflowWrap: "anywhere" }, variant: "body2", children: failure.result.message })) : null] }, failure.vendor))) }) }));
};
export default ApiKeyErrorBanner;
